import React from 'react';
import Btn from './Btn';
import { useOnActionClick } from '../hooks/useOnActionClick';

const PrintOneForm = ({ printForms, actionStyle, requestIds }) => {
  const { loading, onActionClick } = useOnActionClick(requestIds);

  return (
    <Btn
      loading={loading}
      onClick={() => onActionClick(printForms[0])}
      style={actionStyle}
      tooltipTitle="Печатная форма"
    />
  );
};

export default PrintOneForm;
